import { ListItemCard } from '@monorepo/shared/componentsV2/ListItemCard';
import React from 'react';
import { ActionMenu } from '../../menus/ActionMenu';

type FieldTypePreviewProps = {
  actionMenuOptions?: React.ComponentProps<typeof ActionMenu>['options'];
  additionalInfo?: React.ReactElement | string;
  className?: string;
  fieldName: string | React.ReactNode;
  icon?: React.ReactElement;
  iconTooltip?: string;
  isDisabled?: boolean;
  isLocked?: boolean;
  isRequired?: boolean;
  link?: {
    to: string;
    title: string;
  };
  lockedIconTooltip?: string;
  outerElement?: React.ElementType | keyof JSX.IntrinsicElements;
  qualifier?: string | React.ReactNode;
};

export function FieldTypePreview({
  actionMenuOptions,
  additionalInfo,
  className,
  fieldName,
  icon,
  iconTooltip,
  isDisabled = false,
  isLocked = false,
  isRequired = false,
  link,
  lockedIconTooltip,
  outerElement = 'li',
  qualifier,
}: FieldTypePreviewProps) {
  return (
    <ListItemCard
      actionMenuAltText={`Action menu for ${fieldName} field`}
      actionMenuOptions={actionMenuOptions}
      additionalInfo={additionalInfo}
      className={className}
      content={fieldName}
      icon={icon}
      iconTooltip={iconTooltip}
      isDisabled={isDisabled}
      isLocked={isLocked}
      link={link}
      lockedIconTooltip={
        lockedIconTooltip || `The ${fieldName} field cannot be edited.`
      }
      outerElement={outerElement}
      qualifier={qualifier || (isRequired ? 'Required' : undefined)}
    />
  );
}
